const binding = { modules: {}, dataActions: {} };

    (binding.modules['szf-carousel-container'] = {
        c: () => require('partner/modules/szf-carousel-container/szf-carousel-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'szf-carousel-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/szf-carousel-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|szf-carousel-container|szf-carousel-container'] = {
                c: () => require('partner/modules/szf-carousel-container/szf-carousel-container.view.tsx'),
                cn: '__local__-__local__-szf-carousel-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };